import React, { useState } from 'react'
import down_array from '../../../assets/images/down-array.png'
import { withFirebase } from '../../../services'
import LocationMarker from '../LocationMarker'

const LocationModal = (props) => {

    const { firebase, userData, SweetAlert, setSweetAlert, setModalShow } = props

    const [isSaving, setIsSaving] = useState(false)
    const [location, setLocation] = useState(userData.location ? userData.location : '')

    const changeLocation = async (e) => {
        e.preventDefault()
        setIsSaving(true)

        const userId = firebase.auth.currentUser.uid
        const userEmail = firebase.auth.currentUser.email

        try {
            let dataTobeSaved = { ...userData }
            dataTobeSaved.location = location

            // 1️⃣ First check if provider exists
            const snap = await firebase.db
                .collection("healthCareProfessionals")
                .where("email", "==", userEmail)
                .where("isRequestPending", "==", false)
                .limit(1)
                .get();

            if (!snap.empty) {
                // ✅ Provider found → ONLY update address + location
                const providerDoc = snap.docs[0];

                await firebase.db
                    .collection("healthCareProfessionals")
                    .doc(providerDoc.id)
                    .set(
                        {
                            address: location
                        },
                        { merge: true }
                    );

                setIsSaving(false)
                setModalShow(false)

                setSweetAlert({
                    ...SweetAlert,
                    show: true,
                    title: "Location Successfully Updated.",
                    type: "success",
                    onConfirm: () => {
                        setSweetAlert({ ...SweetAlert, show: false })
                         window.location.reload();
                    }
                });

            } else {
                // 2️⃣ Normal user → update users table
                let ref = firebase.db.collection("users").doc(userId);

                await ref.set(dataTobeSaved, { merge: true });

                setIsSaving(false)
                setModalShow(false)

                setSweetAlert({
                    ...SweetAlert,
                    show: true,
                    title: "Location Successfully Updated.",
                    type: "success",
                    onConfirm: () => {
                        setSweetAlert({ ...SweetAlert, show: false })
                         window.location.reload();
                    }
                });
            }

        } catch (error) {
            setIsSaving(false)
            console.log(error)
        }
    }

    return (
        <div className="location">
            <form onSubmit={changeLocation}>
                <div className="form-control locationchange-modal">
                    <LocationMarker
                        value={location}
                        handleChange={(e) => {
                            setLocation(e);
                        }}
                    />
                    <img src={down_array} alt="" />
                    <span className="floating-label">Location</span>
                </div>

                <input
                    type="submit"
                    id="email"
                    name="email"
                    value={isSaving ? "Saving..." : "Save Changes"}
                />
            </form>
        </div>
    )
}

export default withFirebase(LocationModal)